import React from 'react';
import { formValueSelector, reduxForm, Form, Field, change } from 'redux-form';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';
import InputFieldComponent from '../Common/InputFieldComponent/InputFieldComponent';
import RadioFieldComponent from '../Common/RadioFieldComponent/RadioFieldComponent';
import Loader from '../Common/Loader/Loader';
import validate from './validate';
import submit from './submit';
import messages from '../../locale/messages';
import bt from '../commonStyle.css';
import s from './CancelReasonForm.css';


function CancelReasonForm(props) {
    const { cancelReason, cancelLoading, intl: { formatMessage }, bookingId, handleSubmit } = props
    const dispatch = useDispatch()
    const selector = formValueSelector('CancelReasonForm')
    const reason = useSelector(state => selector(state, 'reason'))
    const loading = useSelector(state => state?.loader?.cancelBooking)

    const handleReasonChange = (e) => {
        dispatch(change('CancelReasonForm', 'reason', e.target.value))
        dispatch(change('CancelReasonForm', 'bookingId', bookingId))
    }
    const handleClick = async () => {
        await dispatch(change('CancelReasonForm', 'bookingId', bookingId))
        reason && handleSubmit(submit)();
    }

    const handleClose = () => {
        dispatch(change('reason', null))
        dispatch(change('otherReason', null))
        dispatch(closeHeaderModal('cancelReasonForm'))
    }

    return (
        <>
            {cancelLoading && <Loader type='circle' show={true} />}
            {!cancelLoading &&
                <Form>
                    <div className={s.cancelReasonLabelContainer}>
                        <p className={cx(bt.commonSize14, bt.primaryColor, bt.space0, bt.fontWeight400)}>{formatMessage(messages.cancelReasonSubText)}</p>
                        {cancelReason?.getAllCancelReasons?.results?.length > 0 && cancelReason?.getAllCancelReasons?.results?.map((item, index) => (
                            <div>
                                <RadioFieldComponent
                                    key={index}
                                    name="reason"
                                    size={18}
                                    isTick
                                    value={item.reason}
                                    label={item.reason}
                                    containerClassName={s.cancelReasonLabel}
                                    onChange={(e) => handleReasonChange(e)} />
                            </div>
                        ))}
                        <div>
                            <RadioFieldComponent
                                name="reason"
                                value="other"
                                size={18}
                                isTick
                                label={formatMessage(messages.other)}
                                containerClassName={s.cancelReasonLabel}
                                onChange={(e) => handleReasonChange(e)} />
                        </div>
                        {reason === 'other' && (
                            <Field
                                name="otherReason"
                                type="text"
                                placeholder={formatMessage(messages.cancelReasonLabel)}
                                component={InputFieldComponent}
                                componentClass={"textarea"}
                                inputClass={bt.formTextArea}
                            />
                        )}
                    </div>
                    <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                        <Button onClick={handleClose} className={bt.btnSecondary}><FormattedMessage {...messages.close} /></Button>
                        <Loader
                            type={"button"}
                            buttonType={'button'}
                            show={loading}
                            disabled={!reason}
                            label={formatMessage(messages.proceed)}
                            handleClick={handleClick}
                            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        >
                        </Loader>
                    </div>
                </Form>

            }
        </>

    )
}

CancelReasonForm = reduxForm({
    form: 'CancelReasonForm',
    destroyOnUnmount: false,
    onSubmit: submit,
    validate
})(CancelReasonForm)


export default injectIntl(withStyles(bt, s)(CancelReasonForm));
